import { createMuiTheme } from '@material-ui/core';

export const theme = createMuiTheme({
  overrides: {
    MuiPickersDay: {
      daySelected: {
        backgroundColor: '#63a2e4 !important',
        color: '#fff',
      },
    },
    MuiPickersClock: {
      pin: {
        backgroundColor: '#63a2e4 !important',
      },
    },
    MuiPickersClockPointer: {
      pointer: {
        backgroundColor: '#63a2e4 !important',
      },
    },
    MuiPickersClockNumber: {
      clockNumberSelected: {
        backgroundColor: '#63a2e4 !important',
        color: '#fff',
      },
    },
    MuiPaper: {
      root: {
        '& .MuiPickersDay-daySelected': {
          backgroundColor: '#00a4e4 !important',
          color: '#FFF !important',
        },
        '& .MuiPickersClockNumber-clockNumberSelected': {
          backgroundColor: '#00a4e4 !important',
        },
        '& .MuiPickersDay-day, & .MuiPickersCalendarHeader-dayLabel, & .MuiPickersCalendarHeader-transitionContainer p': {
          color: '#2E3844',
        },
        '& .MuiPickersDay-dayDisabled': {
          color: 'rgba(0, 0, 0, 0.38) !important',
        },
        '& .MuiPickersCalendar-week > div:nth-last-of-type(1) p, & .MuiPickersCalendar-week > div:nth-last-of-type(2) p': {
          fontWeight: 500,
        },
        '& .MuiIconButton-root.Mui-disabled svg': {
          color: 'rgba(0, 0, 0, 0.26) !important',
        },
        '& .MuiPickersCalendarHeader-iconButton svg': {
          color: '#00A4E4',
        },
      },
    },
    MuiContainer: {
      maxWidthLg: {
        maxWidth: '1450px !important',
      },
    },
    MuiButton: {
      root: {
        textTransform: 'none',
        borderRadius: '2px',
      },
      outlined: {
        border: '#CCC',
        color: '#333 !important',
        '&:disabled': {
          color: 'rgba(0, 0, 0, 0.26) !important',
        },
      },
    },
    MuiDialog: {
      paperWidthSm: {
        maxWidth: '735px',
      },
    },
    MuiDialogActions: {
      root: {
        padding: '18px',
      },
    },
    MuiMenuItem: {
      root: {
        fontSize: '0.9rem',
      },
    },
    MuiSelect: {
      root: {
        padding: '10px',
        background: '#fff',
        color: '#536171',
      },
      selectMenu: {
        padding: '6px',
        fontSize: '14px',
      },
    },
    MuiListItem: {
      root: {
        color: '#536171',
      },
      gutters: {
        paddingLeft: '22px',
        paddingRight: '22px',
      },
    },
    MuiInputBase: {
      root: {
        fontSize: '13px',
        fontWeight: 400,
        color: '#333',
      },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 0,
        backgroundColor: '#fff',
        color: '#536171',
        height: '32px',
      },
      adornedEnd: {
        paddingRight: '8px',
      },
      inputMarginDense: {
        paddingTop: '8px',
        paddingBottom: '8px',
      },
      marginDense: {
        padding: '2.815px 0 !important',
      },
    },
    MuiLink: {
      underlineHover: {
        '&:hover': {
          textDecoration: 'none',
        },
      },
    },
    MuiBackdrop: {
      root: {
        backgroundColor: 'transparent',
      },
    },
    MuiFormLabel: {
      root: {
        paddingBottom: '10px',
      },
    },
    MuiTab: {
      root: {
        fontSize: '16px',
        textTransform: 'none',
        maxWidth: 'auto',
        color: '#536171',
      },
    },
    MuiTabs: {
      root: {
        backgroundColor: '#fff',
      },
      indicator: {
        backgroundColor: '#00a4e4',
        height: '3px',
      },
    },
    MuiAppBar: {
      root: {
        boxShadow: 'none',
      },
      colorPrimary: {
        backgroundColor: '#2e3645',
        color: '#fff',
        padding: '16px',
      },
    },
    MuiTypography: {
      subtitle1: {
        fontWeight: 600,
        fontSize: '0.9rem',
      },
      h1: {
        fontSize: '1.25rem',
      },
      caption: {
        fontSize: '0.7rem',
      },
      body2: {
        fontSize: '13px',
      },
    },
    MuiTableSortLabel: {
      icon: {
        fontSize: '24px',
      },
    },
    MuiTooltip: {
      arrow: {
        color: '#000',
        opacity: '0.85 !important',
      },
      tooltip: {
        backgroundColor: '#000',
        opacity: '0.85 !important',
        fontSize: '12px',
      },
    },
    MuiTableCell: {
      sizeSmall: {
        padding: '6px 8px',
      },
    },
  },
  palette: {
    primary: {
      main: '#536171',
      contrastText: '#536171',
    },
    secondary: {
      main: '#00a4e4',
      contrastText: '#fff',
    },
    text: {
      primary: '#536171',
      secondary: '#697686',
    },
  },
});
